import { EnumOrderServiceType, EnumOrderServiceTypeOption } from "./EnumOrderServiceType";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestBLNO {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 
     */
    OrderId?: string;
    /**
     * 
     */
    PoolId?: string;
    /**
     * 关务主键
     */
    OrderDepartureId?: string;
    /**
     * 
     */
    Type?: EnumOrderServiceType;
}

/**
 * -表单校验
 */
export const DtoRequestBLNORules = {
}
